__turbopack_context__.v({
  "cta": "index-module-scss-module__RTgx5G__cta",
  "hide": "index-module-scss-module__RTgx5G__hide",
  "nameAndPrice": "index-module-scss-module__RTgx5G__nameAndPrice",
  "stickyContainer": "index-module-scss-module__RTgx5G__stickyContainer",
  "stickyContent": "index-module-scss-module__RTgx5G__stickyContent",
});
